<div class="panel panel-data">
    <div class="panel-header">
      <h3 class="panel-title">Key Rates</h3>
    </div>
    <div class="panel-tabs tabs">
        <ul class="nav nav-tabs">
            @for (subtab of indicesTabs; track $index) {
                <li class="nav-item">
                    <a (click)="updateIndex(subtab)" class="nav-link" href="javascript:void(0)"
                        [class.active]="this.activeSubtab === subtab">
                        {{ subtab }}
                    </a>
                </li>
            }
        </ul>
    </div>
    <div class="panel-tabs tab-content">
        <div class="tab-pane" [class.active]="this.activeSubtab === indicesTabs[0]">
          <div class="panel-content">
            <ng-container *ngTemplateOutlet="tableLayout; context: { indicators: DailyTreasuryYieldCurveRatesIndicators }"></ng-container>
          </div>
        </div>
        <div class="tab-pane" [class.active]="this.activeSubtab === indicesTabs[1]">
          <div class="panel-content">
            <ng-container *ngTemplateOutlet="tableLayout; context: { indicators: BankOfAmericaMerrillLynchIndicators }"></ng-container>
          </div>
        </div>
    </div>
</div>

<ng-template #tableLayout let-indicators="indicators">
  <table class="table">
    <thead>
      <tr>
        <td class="text-thin">Name</td>
        <td class="text-thin text-right">Current Value (%)</td>
        <td class="text-thin text-right">1M Change</td>
        <td class="text-thin text-right">1Y Change</td>
        <td class="text-thin text-right">Historical Avg.</td>
        <td class="text-thin text-right">Last Update</td>
        <td class="visible-lg-table-cell"></td>
      </tr>
    </thead>
    <tbody>
      @for (indicator of indicators; track indicator.name) {
          <tr>
              <td><a [href]="indicator.url">{{ indicator.name }}</a></td>
              <td class="text-right">{{ indicator.value }}</td>
              <td class="text-right">
                  @if (indicator.change_month_ago !== null) {
                      <span class="text-bold" [class]="indicator.change_month_ago[0] === '-' ? 'text-red': 'text-green'">
                        {{ indicator.change_month_ago }}</span>
                  } @else {
                      --
                  }
              </td>
              <td class="text-right">
              @if (indicator.change_year_ago !== null) {
                  <span class="text-bold" [class]="indicator.change_year_ago[0] === '-' ? 'text-red': 'text-green'">
                    {{ indicator.change_year_ago }}</span>
              } @else {
                  --
              }
              </td>
              <td class="text-right">{{ indicator.long_term_avg !== null ? indicator.long_term_avg: '--' }}</td>
              <td class="text-right">{{ indicator.last_update | date: "MM/d/yy" }}</td>
          </tr>
      }
    </tbody>
  </table>
</ng-template>
